import React, { useEffect, useState, useRef } from 'react';
import './header.css';
import { NavLink } from 'react-router-dom';
import AddIcon from "../../Assets/Clinic_head_icons/addIcon.png"
import PatientIcon from "../../Assets/Clinic_head_icons/patientHistoryIcon.png"

import AddIconAdd from '@mui/icons-material/Add';
import Modal from "../../Components/PopUpModal";
import AddEditAppointment from '../../Pages/Appointment Scheduler/AddEditAppointment';
import useHeader from './Hooks/useHeader';
import FormField from '../../Components/common-components/form-input';

import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import RestartAltIcon from '@mui/icons-material/RestartAlt'
// import UseMedicalHistory from '../Setup/MedicalHistory/Hooks/useMedicalHistory';
import UseMedicalHistory from '../../Pages/Setup/MedicalHistory/Hooks/useMedicalHistory';

import { IoIosShareAlt } from "react-icons/io";
import TableHeadings from '../../Components/common-components/table-headings'
import Pagination from '../../Components/Pagination';
import { getTableHead } from '../../Utils';
import { SelectMedicalForm, SelectMedicalSingleForm } from '../../Pages/PatientManagement/SelectForm';
import AddAndFillForm from '../../Pages/PatientManagement/AddAndFillForm';
import useAddAndFillForm from '../../Pages/PatientManagement/Hooks/useAddAndFillForm';
import { SHARE_CONSENT_FORM, SHARE_MEDICAL_HISTORY_FORM } from '../../repository/patient-form';
import { toast } from 'react-toastify';
import UseForm from '../../PatientPage/Forms/Hooks/useForm';
import ViewForm from '../../PatientPage/Forms/viewForm';
import { Spinner } from '../common-components/spinner';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';
import { Typography } from '@mui/material';
import usePatientDocument from '../../Pages/PatientManagement/Hooks/usePatientDocument';
// import VolumeUpSharpIcon from '@mui/icons-material/VolumeUpSharp';
import ReadMoreButton from '../../Components/common-components/ReadMoreLess';
import { userPatDocumentsURL } from '../../repository/common';
import { Avatar } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

const ChartingHeader = () => {
    const { methods, data } = useHeader()
    const chatContainerRef = useRef(null)

    const { appointmentModal,
        medicalHistoryModalOpen,
        patientHistoryModalOpen,
        patientSummary,
        spinner,
        question,
        isRecording,
        recordingTime,
        isMuted,
        currentAudioRef,
        hasAudio,
    } = data
    const {
        setAppointmentModal,
        setMedicalHistoryModalOpen,
        setPatientHistoryModalOpen,
        patientSummaryHistory,
        setPatientSummary,
        handleChange,
        handleStartRecording,
        handleStopRecording,
        // deletePatientHistory,,
        formatTime,
        setIsMuted,
        showMoreSummary,
        SeemorehandleStartRecording
    } = methods
    const appointmentType = {
        add: 'ADD'
    }
    const { methods: methodsForm, data: dataForm } = UseForm()
    const {
        listData: shareMedicalFormlist,
        spinner: Formspinner,
        viewFormModal,
        filter: filterForm,
        controller: controllerForm,
        totalCount: totalCountForm,
    } = dataForm
    const {
        setViewFormModal,
        form_Details,
        form_List,
        resetFilter: resetFilterForm,
        ApplyFilter: ApplyFilterForm,
        setFilter: setFilterForm,
        setController: setControllerForm
    } = methodsForm


    const { data: medicalData, methods: medicalMethods } = UseMedicalHistory()
    const {
        controller,
        deleteModal: deleteMedicalHistoryModal,
        ShareMedicalHistoryModal,
        spinner: spinnermedical,
        seletedMedicalForm,
        ChooseMedicalHistoryFomrModal,
        patientDetails
    } = medicalData
    const {
        setDeleteModal: setMedicalHistoryDelete,
        handleDelete: handleMedicalHistoryDelete,
        setShareMedicalHistoryModal,
        getMedicalHistoryList,
        setSpinner,
        setSeletedMedicalForm,
        setChooseMedicalHistoryFomrModal
    } = medicalMethods


    let TableHeadDataTableHeadData = [
        { label: '#' },
        { label: 'Form Name' },
        { label: 'Form Category' },
        { label: 'Action' },
    ]

    const TableHeadData = [
        { label: '#' },
        { label: 'Name' },
        { label: 'Gender' },
        { label: 'Age' },
        { label: 'Action' }
    ]

    const familyMemberTableHeadData = getTableHead(false, TableHeadData)

    const { methods: methodsNewAddForm, data: dataNewAddForm } = useAddAndFillForm()
    const {
        addAndFillFormModal,
        spinner: spinnerNewAddForm
    } = dataNewAddForm
    const {
        getFormDetails,
        setaddAndFillFormModal
    } = methodsNewAddForm


    const handleShareMedicalForm = async () => {
        setSpinner(true)
        let payload = {
            formIds: seletedMedicalForm,
            patientId: patientDetails?.id
        }
        try {
            let response = await SHARE_MEDICAL_HISTORY_FORM(payload)
            toast.success(response?.message)
            setShareMedicalHistoryModal({ data: null, open: false })
            setSeletedMedicalForm([])
            // getConsentFormList()
        } catch (err) {
            toast.error(err?.message)
        }
        setSpinner(false)
    }


    const [showNoHistoryMessage, setShowNoHistoryMessage] = useState(false);

    useEffect(() => {
        let timeout;

        if (!patientSummary?.summary) {
            // Wait 5 seconds before showing the fallback message
            timeout = setTimeout(() => {
                setShowNoHistoryMessage(true);
            }, 5000);
        } else {
            // If data is present, don't show fallback
            setShowNoHistoryMessage(false);
        }

        // Clear timeout on cleanup
        return () => clearTimeout(timeout);
    }, [patientSummary?.summary]);


    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [patientSummary]);


    let PatientDocTableHeadData = [
        { label: '#' },
        { label: 'Name' },
        { label: 'Title' },
        { label: 'Description' },
        { label: 'Action' },
    ]

    const { methodsPatient, dataPatient } = usePatientDocument()

    const {
        patientDocList,
        patientDocFormModal,
        patientDocForm,
        patientDocError,
        FileRef,
        deletePatDocModal,
        filter,
        patientDocumentModalOpen,
        spinnerDocument,
        controller: controllerPatientDoc,
        totalCount: totalCountPatientDoc
    } = dataPatient
    const {
        setPatientDocFormModal,
        handlePatientDocInput,
        handleFileChange,
        submitPatientDocument,
        handleRemovePatDocFile,
        clearPatDocForm,
        deletePatientCard,
        setDeletePatDocModal,
        setFilter,
        resetFilter,
        ApplyFilter,
        setPatientDocumentModalOpen,
        setController: setControllerPatientDoc
    } = methodsPatient
    return (
        <>
            <header id="header" className={`nestedHeader  d-flex align-items-center`} style={{ background: "#0F6CBD" }}>
                <nav>
                    <ul className="nav-links">
                        {/* <li onClick={() => setAppointmentModal({ data: '', type: appointmentType?.add, open: true })}><img src={AddIcon} />Create Appointment</li> */}
                        {/* <li className='d-flex align-items-center ' onClick={() => (setHippModeOnOff(!hippModeOnOff))}> {hippModeOnOff ? <IoMdEyeOff className='font-18 me-1' /> : <IoEye className='font-18 me-1' />}  Privacy Mode</li> */}
                        <NavLink to={"/perio-chart"}><li><img src={AddIcon} alt='' /> Perio Chart</li></NavLink>
                        {/* <li><NavLink to={"/perio-graph"}><img src={AddIcon} alt='' /> Perio Graph</NavLink></li> */}
                        <NavLink to={"/e-prescription"}><li><img src={AddIcon} alt='' /> E-Prescription </li></NavLink>
                        <NavLink to={"/patient-notes"}><li><img src={AddIcon} alt='' /> Notes </li></NavLink>
                        <NavLink
                            onClick={(e) => {
                                e.preventDefault();
                                setMedicalHistoryModalOpen(true);
                            }}>
                            <li>
                                <img src={AddIcon} alt='' />
                                Medical History
                            </li>
                        </NavLink>

                        <NavLink
                            onClick={(e) => {
                                e.preventDefault();
                                setPatientHistoryModalOpen(true);
                                // patientSummaryHistory()
                            }}>
                            <li>
                                <img style={{ width: 32, height: 32 }} src={PatientIcon} alt='' />
                                Patient History
                            </li>
                        </NavLink>

                        <NavLink
                            onClick={(e) => {
                                e.preventDefault();
                                setPatientDocumentModalOpen(true);
                            }}>
                            <li>
                                <img src={AddIcon} alt='' />
                                Patient Document
                            </li>
                        </NavLink>

                        {/* <li className='d-flex align-items-center '><NavLink ><ImFileText className='font-18 me-1' />Appointment Requests</NavLink></li> */}
                    </ul>
                </nav>
            </header>


            {/* edit appointment Modal */}
            <Modal className="p-0"
                size="xl" show={appointmentModal?.open} onHide={() => {
                    setAppointmentModal({ data: null, open: false })
                    // clearForm()
                    // setStateError({});
                }}
                headerContent={<h5 className="py-2 mb-0 fw-6 font-16">Create Appointment</h5>}

                bodyContent={
                    <AddEditAppointment data={data} type={appointmentType} methods={methods} />
                }
            />

            {/* Medical History Modal */}
            {medicalHistoryModalOpen && (
                <Modal
                    show={medicalHistoryModalOpen}
                    onHide={() => setMedicalHistoryModalOpen(false)}
                    size="xl"
                    scrollable
                    dialogClassName="medical-history-modal"

                    bodyContent={
                        <div className='row m-3 mt-4 mt-lg-3'>
                            <div className='col-12 shadow-sm p-0'>
                                <div className='d-flex justify-content-center shadow-sm bgLightBlue1 text-white font-14 fw-5 p-1'>
                                    Medical History
                                </div>

                                <div className="p-3">
                                    {/* Header with search + actions */}
                                    <div className='d-flex justify-content-between align-items-center flex-wrap gap-2'>
                                        <div className='blue3 fw-6 font-13'>View Medical History</div>
                                        <div className='d-flex align-items-center'>
                                            <FormField
                                                data={{ placeholder: 'Search', rightIcon: '', type: 'text' }}
                                                value={filterForm?.search}
                                                onChange={(e) => setFilterForm(prev => ({ ...prev, search: e.target.value }))}
                                            />
                                            <button className="theme-btn bgDarkBlue ms-2" onClick={ApplyFilterForm}>
                                                <SearchIcon style={{ height: "20px" }} /> Search
                                            </button>
                                            <button className="theme-btn bgDarkBlue ms-2" onClick={resetFilterForm}>
                                                <RestartAltIcon style={{ height: "20px" }} /> Reset
                                            </button>
                                            <button className="theme-btn bgLightGreen ms-2"
                                                onClick={() => {
                                                    setChooseMedicalHistoryFomrModal(prev => ({ ...prev, open: true }));
                                                    getMedicalHistoryList(true);
                                                }}>
                                                <AddIconAdd style={{ height: "20px" }} /> Add New
                                            </button>
                                            <button className="theme-btn bgLightGreen ms-2" onClick={() => {
                                                setShareMedicalHistoryModal(prev => ({ ...prev, open: true }));
                                                getMedicalHistoryList(true);
                                            }}>
                                                <IoIosShareAlt style={{ height: "20px" }} /> Share Medical History Form
                                            </button>
                                        </div>
                                    </div>

                                    {/* Table */}
                                    <div className="col-12 mt-3 pb-3">
                                        <table className="customTable">
                                            <TableHeadings TableHeadData={TableHeadDataTableHeadData} />
                                            <tbody>
                                                {shareMedicalFormlist?.map((resp, index) => (
                                                    <tr key={index}>
                                                        <td>{controllerForm.rowsPerPage * (controllerForm.page - 1) + index + 1}</td>
                                                        <td>{resp?.formName || "--"}</td>
                                                        <td>{resp?.formCategoryName || "--"}</td>
                                                        <td>
                                                            <CreateIcon
                                                                className='cursor font-18'
                                                                color="primary"
                                                                titleAccess='Edit'
                                                                onClick={() => {
                                                                    form_Details(resp?.id);
                                                                    setViewFormModal(prev => ({ ...prev, data: resp, open: true }));
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {!shareMedicalFormlist?.length && (
                                            <div className="text-center mt-2">No record found</div>
                                        )}

                                        <div className="d-flex justify-content-center mt-2">
                                            {
                                                totalCountForm > controllerForm.rowsPerPage && (
                                                    <Pagination
                                                        count={totalCountForm}
                                                        controller={controllerForm}
                                                        setController={setControllerForm}
                                                    />
                                                )
                                            }
                                        </div>

                                        <div className='d-flex justify-content-end'>
                                            <button
                                                className="theme-btn black1 mt-4 px-5"
                                                onClick={() => {
                                                    setMedicalHistoryModalOpen(false);
                                                }}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                />
            )}


            {/* Patient History Modal */}
            <Drawer
                anchor="right"
                open={patientHistoryModalOpen}
                onClose={() => {
                    setPatientHistoryModalOpen(false);
                    setPatientSummary([]);
                }}
                PaperProps={{
                    sx: { width: { xs: '100%', sm: '400px', md: '500px', lg: '600px' }, padding: '10px' }
                }}
            >
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                    {/* Header */}
                    <div className='d-flex justify-content-end mb-2'>
                        <CloseIcon onClick={() => setPatientHistoryModalOpen(false)} sx={{ display: 'flex', justifyContent: 'end', padding: '0px', cursor: 'pointer' }} />
                    </div>
                    <Box className='d-flex justify-content-center shadow-sm bgLightBlue1 text-white font-14 fw-5 p-2'>
                        Patient Summary
                    </Box>
                    {/* Content */}
                    <Box sx={{ flex: 1, overflow: 'auto', p: 3 }} ref={chatContainerRef}>
                        {patientSummary.map((item, index) => (
                            <div key={index} className="mb-3">
                                {item.summary && (
                                    <>
                                        {/*  QUESTION */}
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span className="fw-bolder">{item.question}</span>
                                        </div>

                                        {/*  SUMMARY */}
                                        <div className="position-relative mt-2">
                                            <p
                                                className="font-12 blackLight chat_message_bg_color_1 chat_message_padding_1"
                                                style={{ whiteSpace: "pre-line" }}
                                            >
                                                {item.summary}
                                                {/*  SHOW MORE */}
                                                
                                                    {item.hasMore && !item.isLoading && (
                                                        <button
                                                            className="theme-btn bgDarkBlue mt-2"
                                                            onClick={() =>
                                                                item.isAudio
                                                                    ? SeemorehandleStartRecording(index)
                                                                    : showMoreSummary(index)
                                                            }
                                                        >
                                                            Show more
                                                        </button>
                                                    )}
                                                {/* {item.hasMore && !item.isLoading && (
                                                    <button
                                                        className="theme-btn bgDarkBlue mt-2"
                                                        onClick={() => showMoreSummary(index)}
                                                    >
                                                        Show more
                                                    </button>
                                                )} */}

                                                {/*  LOADER */}
                                                {item.isLoading && (
                                                    <span
                                                        className="ms-2 spinner-border spinner-border-sm text-primary"
                                                        role="status"
                                                    />
                                                )}
                                            </p>

                                            <div className="CHAT_ARROW1"></div>
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                        {patientSummary?.length === 0 && <p className='text-center' style={{ top: "40%" }}>No record found</p>}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TextField
                            fullWidth
                            placeholder="Type your question..."
                            variant="outlined"
                            size="small"
                            value={question}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    if (question.trim()) {
                                        patientSummaryHistory();
                                    }
                                }
                            }}
                        />
                        <IconButton
                            onClick={() => {
                                if (question.trim()) {
                                    patientSummaryHistory();
                                }
                            }}
                            disabled={!question.trim()}
                            sx={{
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                '&:hover': { background: '#f5f5f5' },
                                '&.Mui-disabled': {
                                    opacity: 0.5,
                                    cursor: 'not-allowed'
                                }
                            }}
                        >
                            <SendIcon sx={{ color: !question.trim() ? '#ccc' : '#22c55e' }} />
                        </IconButton>
                        {/* Recording Controls */}
                        {!isRecording ? (
                            <IconButton
                                onClick={handleStartRecording}
                                sx={{ border: '1px solid #ddd', borderRadius: '4px' }}
                                title="Start Recording"
                            >
                                <MicIcon sx={{ color: '#22c55e' }} />
                            </IconButton>
                        ) : (
                            <IconButton
                                onClick={handleStopRecording}
                                sx={{ border: '1px solid #ddd', borderRadius: '4px' }}
                                title="Stop Recording"
                            >
                                <StopIcon sx={{ color: '#f87171' }} />
                            </IconButton>
                        )}


                        {/* Timer Display */}
                        {isRecording && (
                            <Typography variant="body2" sx={{ minWidth: '50px' }}>
                                {formatTime(recordingTime)}
                            </Typography>
                        )}

                        {/*  Mute/Unmute Button */}
                        {hasAudio && (
                            <IconButton
                                onClick={() => {
                                    setIsMuted(prev => {
                                        const newMuteState = !prev;
                                        if (currentAudioRef.current) {
                                            currentAudioRef.current.muted = newMuteState; // mute/unmute current audio
                                        }
                                        return newMuteState;
                                    });
                                }}
                                sx={{ border: '1px solid #ddd', borderRadius: '4px' }}
                                title={isMuted ? "Unmute AI" : "Mute AI"}
                            >
                                {isMuted ? <VolumeOffIcon sx={{ color: '#f87171' }} /> : <VolumeUpIcon sx={{ color: '#22c55e' }} />}
                            </IconButton>
                        )}

                        {/* Optional Audio Playback */}
                        {/* {audioUrl && (
                            <Box sx={{ mt: 1, width: '100%' }}>
                                <Typography variant="body2" gutterBottom>
                                    Recorded Audio:
                                </Typography>
                                <audio controls src={audioUrl} style={{ width: '100%' }} />
                            </Box>
                        )} */}
                    </Box>
                </Box>
            </Drawer>


            {/* Select medical single form for form fill and and  */}
            <Modal className="p-0" size="lg" show={ChooseMedicalHistoryFomrModal?.open} onHide={() => { setChooseMedicalHistoryFomrModal({ data: null, open: false }) }}
                bodyContent={
                    <>
                        <div className='text-center bgDarkBlue2 white py-1 font-15 fw-6'> Medical History</div>
                        <SelectMedicalSingleForm data={medicalData} methods={medicalMethods} getFormDetails={getFormDetails} setaddAndFillFormModal={setaddAndFillFormModal} />
                    </>
                }
            />
            {/* Form Modal  new form Medical History for */}
            <Modal className="p-0" size="xl" show={addAndFillFormModal?.open} onHide={() => { setaddAndFillFormModal({ data: {}, open: false }) }}
                bodyContent={
                    <>
                        <div className='text-center bgDarkBlue2 white py-1 font-15 fw-6'>Create Medical History</div>
                        <AddAndFillForm data={dataNewAddForm} methods={methodsNewAddForm} patientDetails={patientDetails} form_List={form_List} />
                    </>
                }
            />

            {/* share  Medical History  Form Modal  */}
            <Modal className="p-0" size="lg" show={ShareMedicalHistoryModal?.open} onHide={() => { setShareMedicalHistoryModal({ data: null, open: false }) }}
                bodyContent={
                    <>
                        <div className='text-center bgDarkBlue2 white py-1 font-15 fw-6'> Medical History</div>
                        <SelectMedicalForm data={medicalData} methods={medicalMethods} handleShareMedicalForm={handleShareMedicalForm} />
                    </>
                }
            />

            {/* View Form */}
            <Modal className="p-0" HeaderClass={'p-0'} size="xl" show={viewFormModal?.open} onHide={() => { setViewFormModal({ data: null, open: false }) }}
                bodyContent={<ViewForm data={dataForm} methods={methodsForm} />}
            />




            {/* Patient Document Modal */}
            {patientDocumentModalOpen && (
                <Modal
                    show={patientDocumentModalOpen}
                    onHide={() => setPatientDocumentModalOpen(false)}
                    size="xl"
                    scrollable
                    dialogClassName="medical-history-modal"
                    bodyContent={
                        <div className='row m-3 mt-4 mt-lg-3'>
                            <div className='col-12 shadow-sm p-0'>
                                <div className='d-flex justify-content-center shadow-sm bgLightBlue1 text-white font-14 fw-5 p-1'>Patient Document</div>
                                <div>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <div className='blue3 fw-6 font-13'> View Patient Document</div>
                                    </div>
                                    <div className="" >
                                        <div className="">
                                            <div className="d-sm-flex d-md-flex d-lg-flex align-items-center justify-content-between">
                                                <div className='d-flex'>
                                                    <div className='pt-2'>
                                                        <FormField data={{ placeholder: 'Search', rightIcon: '', type: 'text' }} value={filter?.search} onChange={(e) => setFilter((prev) => ({ ...prev, search: e.target.value }))} />
                                                    </div>
                                                    <div className="d-flex ms-2">
                                                        <button className="theme-btn bgDarkBlue  mt-3 mx-lg-2 mx-md-2 mx-sm-2 me-2" onClick={ApplyFilter} > <SearchIcon style={{ height: "20px" }} /> Search</button>
                                                        <button className="theme-btn bgDarkBlue  mt-3 mx-lg-2 mx-md-2 mx-sm-2 me-2" onClick={resetFilter} > <RestartAltIcon style={{ height: "20px" }} /> Reset</button>
                                                        <button className="theme-btn bgLightGreen mt-3 ms-2" onClick={() => setPatientDocFormModal((pre) => ({ ...pre, open: true }))}
                                                        >
                                                            <AddIconAdd style={{ height: "20px" }} />
                                                            Add New</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 mt-3 pb-3" >
                                                <table className="customTable">
                                                    <TableHeadings TableHeadData={PatientDocTableHeadData} />
                                                    <tbody>
                                                        {
                                                            patientDocList?.map((resp, index) =>
                                                                <tr key={index}>
                                                                    <>
                                                                        <td >{controllerPatientDoc.rowsPerPage * (controllerPatientDoc.page - 1) + index + 1}</td>
                                                                        <td className='  ' >{resp?.firstName ? resp?.firstName : "-"}{resp?.lastName ? resp?.lastName : "-"}</td>
                                                                        <td className=' ' >{resp?.title || '--'}</td>
                                                                        <td className=' ' >{<ReadMoreButton maxLength={100} text={resp?.description} /> || '--'}</td>
                                                                        <td >
                                                                            <div className='d-flex'>
                                                                                {resp?.documents?.map((doc, index) => (
                                                                                    <a
                                                                                        key={index}
                                                                                        href={userPatDocumentsURL + doc}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                    >
                                                                                        <VisibilityIcon className='cursor font-18' />
                                                                                    </a>
                                                                                ))}
                                                                                <CreateIcon className='cursor font-18' color="primary" titleAccess='Edit'
                                                                                    onClick={() => { setPatientDocFormModal({ data: resp, open: true }) }}
                                                                                />
                                                                                <DeleteIcon className='cursor red font-18' onClick={() => setDeletePatDocModal({ data: resp?.id, open: true })} />

                                                                            </div>
                                                                        </td>
                                                                    </>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                                {!patientDocList?.length && <div className="text-center mt-2">No record found</div>}

                                                <div className="d-flex justify-content-center mt-2 mb-2">
                                                    {
                                                        totalCountPatientDoc > controllerPatientDoc.rowsPerPage && (
                                                            <Pagination
                                                                count={totalCountPatientDoc}
                                                                controller={controllerPatientDoc}
                                                                setController={setControllerPatientDoc}
                                                            />
                                                        )
                                                    }
                                                </div>
                                            </div>

                                            <div className='d-flex justify-content-end mb-3 p-2'>
                                                <button
                                                    className="theme-btn black1 mt-4 px-5"
                                                    onClick={() => {
                                                        setPatientDocumentModalOpen(false);
                                                    }}
                                                >
                                                    Close
                                                </button>
                                            </div >
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                />
            )}


            {/* Patient Document Form Modal */}
            <Modal
                size="md" show={patientDocFormModal?.open} onHide={() => { clearPatDocForm(); }}
                bodyContent={
                    <div className='m-3 m-lg-4 mt-4 mt-lg-2'>
                        <div className="row">
                            <div className="col-12 mt-3">
                                <div className='row'>
                                    <div className=" col-12 ">
                                        <FormField
                                            maxLength={50}
                                            name={'title'}
                                            value={patientDocForm.title}
                                            // onBlur={(e) => handleBlur(e)}
                                            onChange={(e) => handlePatientDocInput(e)}
                                            error={patientDocError?.title}
                                            required={true}
                                            data={{ label: 'Title', placeholder: '', type: 'text' }} />
                                    </div>

                                </div>
                            </div>
                            <div className="col-12 border-bottom pb-4">
                                {spinnerDocument && <Spinner />}
                                <div className='row'>
                                    <div className=" col-12 mt-2">
                                        <label className={'fw-6 font-11 p-0 text-nowrap'} >{"Description"}</label>
                                        <textarea className=' rounded-1 border' rows="4"
                                            name='description'
                                            onChange={(e) => handlePatientDocInput(e)}
                                            value={patientDocForm?.description}
                                        ></textarea>
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-12 ">
                                        <div className='mt-3'>
                                            <label className='d-block font-11 fw-6 pb-1'>Upload Documents </label>
                                            {!patientDocForm?.documents?.length ? (
                                                <div className='bgGrey1 p-1 px-2 rounded-1'>
                                                    {/* <input type="file" className='p-0 font-14' /> */}
                                                    <input
                                                        multiple
                                                        type="file"
                                                        ref={FileRef}
                                                        className='p-0 font-14'
                                                        accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.txt"
                                                        name="file"
                                                        onChange={handleFileChange}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="d-flex">
                                                    {patientDocForm?.documents?.map((doc, index) => {
                                                        const fileName = typeof doc === 'string' ? doc : doc?.name || '';
                                                        const fileExtension = fileName.toLowerCase().split('.').pop();

                                                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension);
                                                        const isPDF = fileExtension === 'pdf';

                                                        return (
                                                            <div key={index} className="d-flex align-items-center me-2">
                                                                {isImage ? (
                                                                    <Avatar
                                                                        alt="Document Preview"
                                                                        sx={{ width: 40, height: 40 }}
                                                                        src={typeof doc === 'string' ? userPatDocumentsURL + doc : URL.createObjectURL(doc)}
                                                                    />
                                                                ) : (
                                                                    <Avatar
                                                                        alt="File Icon"
                                                                        sx={{
                                                                            width: 40,
                                                                            height: 40,
                                                                            bgcolor: isPDF ? 'error.main' : 'grey.400',
                                                                            color: 'white',
                                                                        }}
                                                                    >
                                                                        {isPDF ? <PictureAsPdfIcon /> : <InsertDriveFileIcon />}
                                                                    </Avatar>
                                                                )}

                                                                <p
                                                                    className="text-danger border rounded px-1 cursor ms-1"
                                                                    onClick={() => handleRemovePatDocFile(index)}
                                                                >
                                                                    x
                                                                </p>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex mt-4 justify-content-end'>
                            <div >  <button className='theme-btn bgLightGray px-30' onClick={() => { clearPatDocForm() }}>Discard</button> </div>
                            {patientDocFormModal?.data?.id ? <div className='ms-3 '>  <button className='theme-btn bgDarkBlue3 px-30' onClick={() => submitPatientDocument("EDIT")}>Update</button> </div> : <div className='ms-3 '>  <button className='theme-btn bgDarkBlue3 px-30' onClick={submitPatientDocument}>Submit</button> </div>}

                        </div>
                    </div>
                }
            />


            {/* Delete Modal of Patient Document */}
            <Modal
                size="md" headerBorderBottom={true} show={deletePatDocModal?.open} onHide={() => { setDeletePatDocModal({ data: {}, open: false }) }}
                bodyContent={
                    <div>
                        <div className="text-center col-12">
                            <div className='mt-3 mb-4'>
                                <DeleteIcon className='cursor red' sx={{ fontSize: '50px' }} />
                            </div>
                            <div className="fw-6 font-22">Delete  Patient Document ?</div >
                            <div className="grey-color font-15 my-2">
                                You are about to delete this Patient Document  <br /> Are you sure?
                            </div>
                        </div>
                        <div className="d-flex justify-content-center mt-4 mb-4">
                            <button type="button" className="theme-btn  col-5 font-12 fw-5 bgRed" onClick={deletePatientCard}>Delete</button>
                        </div>
                    </div>
                }
            />
        </>
    )
}

export default ChartingHeader

